import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const ToggleButton = ({ text, section, isSectionOpen, setOpenSection}) => {
    const toggleSection = () => setOpenSection(isSectionOpen ? '' : section);
    const buttonAriaLabel = isSectionOpen ? `Collapse ${section}` : `Expand ${section}`;

    return (
        <Button
            color="link"
            onClick={toggleSection}
            className="button-frame"
            aria-label={buttonAriaLabel}
        >
            {text}
            <FontAwesomeIcon icon={isSectionOpen ? faChevronUp : faChevronDown} className="arrow" />
        </Button>
    );
};

export default ToggleButton;